import Swal from 'sweetalert2'
import { PopUpContainer, PopUpHeader, PopUpTitle, PopUpContent, FieldGroup, Label, Input, TextArea } from './style'
import { withPopupTheme } from '../withPopupTheme'
import { renderToString } from 'react-dom/server'
import React from 'react'

export interface ConnectionDataModalProps {
  source: string
  responsible: string
  areaInterest: string
  description: string
}
export const connectionDataModal = ({ source, responsible, areaInterest, description }: ConnectionDataModalProps): void => {
  const content = withPopupTheme(
    <PopUpContainer>
      <PopUpHeader>
        <PopUpTitle>Sobre a conexão</PopUpTitle>
      </PopUpHeader>
      <PopUpContent>
        <FieldGroup>
          <Label>Fonte de conexão</Label>
          <Input value={source} disabled={true} />
        </FieldGroup>
        <FieldGroup>
          <Label>Responsável pela conexão</Label>
          <Input value={responsible} readOnly={true} disabled={true} />
        </FieldGroup>
        <FieldGroup>
          <Label>Área/instituição de interesse</Label>
          <Input value={areaInterest} readOnly={true} disabled={true} />
        </FieldGroup>
        <FieldGroup>
          <Label>Descrição</Label>
          <TextArea value={description} rows={4} readOnly={true} disabled={true} />
        </FieldGroup>
      </PopUpContent>
    </PopUpContainer>
  )
  Swal.fire({
    showCloseButton: true,
    showConfirmButton: false,
    showCancelButton: false,
    allowOutsideClick: true,
    customClass: {
      popup: 'connection-data-modal',
      closeButton: 'connection-data-modal-close',
      container: 'connection-data-modal-container',
      actions: 'connection-data-actions'
    },
    html: renderToString(content),
    width: '800px',
    padding: 0,
    backdrop: 'rgba(0,0,0,0.4)'
  })
}